// 日付・通貨・数値の整形（台湾慣用 zh-TW）。CLAUDE.md ★言語方針。

import { CURRENCIES, labelOf } from "../masters";

// 内部通貨コード → Intl 用 ISO コード（NTD は ISO では TWD）。
const ISO_CURRENCY: Record<string, string> = {
  NTD: "TWD",
  JPY: "JPY",
  USD: "USD",
};

export function formatAmount(amount: number | null, currency: string | null): string {
  if (amount === null || amount === undefined) return "—";
  const iso = currency ? ISO_CURRENCY[currency] ?? "TWD" : "TWD";
  try {
    return new Intl.NumberFormat("zh-TW", {
      style: "currency",
      currency: iso,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${labelOf(CURRENCIES, currency)} ${amount.toLocaleString("zh-TW")}`;
  }
}

// ISO タイムスタンプ → "2026/06/28 14:30"（台北時間）。
export function formatDateTime(value: string | null): string {
  if (!value) return "—";
  const d = new Date(value.length === 10 ? `${value}T00:00:00Z` : value);
  if (Number.isNaN(d.getTime())) return value;
  return new Intl.DateTimeFormat("zh-TW", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Asia/Taipei",
  }).format(d);
}

// "YYYY-MM-DD" や ISO タイムスタンプ → "2026/06/28"。
export function formatDate(value: string | null): string {
  if (!value) return "—";
  const d = new Date(value.length === 10 ? `${value}T00:00:00Z` : value);
  if (Number.isNaN(d.getTime())) return value;
  return new Intl.DateTimeFormat("zh-TW", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Taipei",
  }).format(d);
}
